import React from 'react';
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {PencilIcon, TrashIcon} from "@heroicons/react/solid";
import {Contact} from "../../../types/Contact";

// Types ----

type ContactContextMenuProps = {
  contact: Contact
  onDelete: () => void
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function ContactContextMenu({contact, onDelete, editDisabled, deleteDisabled, position = 'right'}: ContactContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function editContact() {
    void navigate(`/contacts/${contact.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {auth.can('contacts:write') &&
        <DropdownItem
          name="Edit"
          icon={PencilIcon}
          onClick={editContact}
          disabled={!!editDisabled}
        />
      }

      {/* TODO: This is a temporary solution to prevent Audience Managers deleting audience members */}
      {(auth.can('users:write') && !auth.roles.includes('audience manager')) &&
        <DropdownItem
          name="Delete"
          icon={TrashIcon}
          onClick={onDelete}
          disabled={!!deleteDisabled}
        />
      }
    </Dropdown>
  );
}

export default ContactContextMenu;